<template>
    <div class="w-full lg:w-3/4">
        <div class="pt-2 pb-1 text-2xl font-bold">Steps</div>

        <div class="rounded-t overflow-hidden border border-b-0">
            <table class="table w-full">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th class="text-left">Description</th>
                        <th></th>
                    </tr>
                </thead>
                <draggable
                    tag = "tbody"
                    v-model="form.sop_steps"
                    item-key="index"
                    sort="true"
                    direction="vertical"
                    @start="dragging = true" 
                    @end="dragging = false"
                    handle=".drag-handle"
                >

                    <template #item="{ element: step, index }">
                        <tr>
                            <td
                                :style="{'cursor':  (dragging ? 'grabbing' : 'grab')}"
                                class="drag-handle whitespace-nowrap">⠿ {{  Number(index) + 1 }} 
                            </td>
                            <td class="text-center">
                                <!-- Uploaded Image -->
                                <div
                                    v-if="step.uploads.length"
                                    class="group inline-block relative"
                                >
                                    <img
                                        class="h-auto w-40 rounded-md"
                                        :src="`/storage/${step.uploads[0].path}`" 
                                        @click="openInNewTab(`/storage/${step.uploads[0].path}`)"
                                    />
                                    <jet-danger-button
                                        class="hidden group-hover:inline-block absolute bottom-2 left-1/2 -translate-x-1/2 px-1"
                                        @click="removeUploadedFile(index)"
                                    >
                                        <img src="/images/icons/trash_w.svg" width="16" height="16" alt="Delete" style="min-width: 16px;"/>
                                    </jet-danger-button>
                                </div>

                                <div v-else>
                                    <!-- Preview Image -->
                                    <div v-if="step.previewImage">
                                        <div class="group inline-block relative">
                                            <img class="h-auto w-40 rounded-md" :src="step.previewImage" />
                                            <jet-danger-button
                                                class="hidden group-hover:inline-block absolute bottom-2 left-1/2 -translate-x-1/2 px-1"
                                                @click="removePendingFile(index)"
                                            >
                                                <img src="/images/icons/trash_w.svg" width="16" height="16" alt="Delete" style="min-width: 16px;"/>
                                            </jet-danger-button>
                                        </div>
                                    </div>
                                    
                                    <!-- Upload Image -->
                                    <file-input-label v-else>
                                        <jet-input class="hidden" @change="handleFileChange($event, index)" type="file" accept="image/*" />
                                    </file-input-label>
                                </div>
                            </td>

                            <td>
                                <quill-editor 
                                    v-model:content="step.description"
                                    contentType="html"     
                                    theme="snow"
                                    class="h-32" 
                                    required
                                    :toolbar="[
                                        [{ header: [2, 3, 4, 5, 6, false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                        [{ 'indent': '-1'}, { 'indent': '+1' }],
                                        [{ 'color': [] }],
                                        ['link'],
                                        ['clean'],
                                    ]"
                                />
                            </td>

                            <td>
                                <jet-secondary-button @click="deleteStep(step, index)">
                                    <img src="/images/icons/trash_w.svg" width="16" height="16" alt="Delete" style="min-width: 16px;"/>
                                </jet-secondary-button>
                            </td>
                        </tr>
                    </template>

                </draggable>
            </table>
        </div>

        <jet-button type="button" @click="appendStepToForm" class="mt-3">
            Add
        </jet-button>
    </div>
</template>

<script>
import JetButton from '@/Jetstream/Button';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import FileInputLabel from '@/Jetstream/FileInputLabel';
import draggable from 'vuedraggable';
import { QuillEditor } from '@vueup/vue-quill';

import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
    components: {
        JetButton,
        JetDangerButton,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetTertiaryButton,
        FileInputLabel,
        draggable,
        QuillEditor
    },

    props: ['form'],

    data() {
        return {
            dragging: false,
            test:''
        }
    },

    mounted () {
        //
    },

    computed: {
        //
    },

    methods: {
        appendStepToForm(){
            this.form.sop_steps.push({
                id: null,
                description: null,
                uploads: [],
                pendingImage: null,
                previewImage: null,
            });
        },

        deleteStep(step, index){
            if(step.id){
                axios.delete(`/sop-steps/${step.id}`)
                .then((response) => {
                    const index = this.form.sop_steps.findIndex(s => s.id === step.id);
                    if (index !== -1) {
                        this.form.sop_steps.splice(index, 1)
                    }
                    EventBus.emit('show-alert', {
                        type: 'success',
                        title: `Success`,
                        message: `Step deleted`
                    });
                })
            } else {
                this.form.sop_steps.splice(index, 1)
            }
        },

        deleteSop() {
            axios.delete(`/sops/${this.sop.id}`)
            .then(res=>{
                this.$inertia.visit('/sops',  {
                    onSuccess: () => {
                        EventBus.emit('show-alert', {
                            type: 'success',
                            title: `Success`,
                            message: `SOP deleted`
                        });
                    }
                });
            })
        },

        handleFileChange(event, index){
            const file = event.target.files[0];
            const preview = URL.createObjectURL(file);

            this.form.sop_steps[index].pendingImage = file;
            this.form.sop_steps[index].previewImage = preview;
        },

        removePendingFile(index){
            this.form.sop_steps[index].pendingImage = null;
            this.form.sop_steps[index].previewImage = null;
        },

        removeUploadedFile(index){
            this.form.sop_steps[index].uploads.splice(0);
        },
    },

    watch: {
        //
    }
}
</script>